import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=7db8b4b2&scoped=true&lang=pug"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"
import style0 from "./tabbar.vue?vue&type=style&index=0&id=7db8b4b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8b4b2",
  null
  
)

export default component.exports